
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Acbushireforemployees() {



    const cardData =
    {
        keyword: 'AC Bus Hire for Employees Pune',
        heading: 'etravo : AC Bus Hire for Employees Pune',
        headingDescription: 'eTravo provides AC Bus Hire for Employees in Pune, ensuring a smooth, comfortable, and climate-controlled commute for corporate teams and industrial staff. Ideal for daily office transportation, shift-based travel, and long-distance commutes, our air-conditioned buses are spacious, well-maintained, and equipped with GPS tracking for real-time monitoring. Driven by courteous, trained chauffeurs, our services prioritize punctuality, safety, and employee convenience. Whether you’re managing transport for a startup or a large enterprise, eTravo’s AC bus rentals in Pune offer scalable, reliable, and cost-effective solutions for your workforce mobility needs.',

        top: 'Top Places to Visit in Pune with etravo',
         "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Built in 1732 as the seat of the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fortification in Pune. Though much of it was destroyed in an 1828 fire, the surviving structures and gardens offer a glimpse into its grand past. The site is renowned for its architectural features and is a popular tourist attraction."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Constructed in 1892 by Sultan Muhammed Shah Aga Khan III, this palace played a significant role during India's freedom movement. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi during the Quit India Movement. The palace now houses a museum and memorials dedicated to Gandhi and his associates."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located approximately 28 km southwest of Pune, Sinhagad Fort is a hill fortress known for the Battle of Sinhagad in 1670. The fort offers panoramic views and is a popular destination for trekking enthusiasts. It houses memorials and remnants of historical significance."
    },
    {
      "title": "Dagdusheth Halwai Ganapati Temple",
      "description": "This renowned temple is dedicated to Lord Ganesha and is famous for its rich history and the grand idol adorned with gold. It attracts thousands of devotees, especially during the Ganesh Chaturthi festival."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple is carved from a single basalt rock. The temple complex includes a circular Nandi mandapa and is a protected monument under the Archaeological Survey of India."
    },
    {
      "title": "Osho International Meditation Resort",
      "description": "Situated in Koregaon Park, this meditation center offers a tranquil environment for spiritual growth and wellness. It attracts visitors worldwide seeking meditation and personal development programs."
    },
    {
      "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped garden symbolizes the Indo-Japanese friendship. It features manicured lawns, waterfalls, and a serene environment."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses an extensive collection of artifacts showcasing India's rich cultural heritage. Exhibits include musical instruments, sculptures, and everyday objects from the 18th and 19th centuries."
    },
    {
      "title": "Koregaon Park",
      "description": "A vibrant neighborhood known for its lush greenery, upscale eateries, and cultural hubs. Koregaon Park is a popular destination for dining, shopping, and experiencing Pune's cosmopolitan lifestyle."
    },
    {
      "title": "Lal Mahal",
      "description": "Originally built in the 17th century, Lal Mahal is historically significant as the childhood residence of Chhatrapati Shivaji Maharaj. The reconstructed palace now serves as a museum showcasing Maratha history."
    }
  ],



"services": [
  {
    "name": "AC Bus Hire for Employees Pune",
    "description": "eTravo offers AC bus hire for employees in Pune, providing cool and comfortable commuting for daily office travel, industrial zones, and IT parks. Ideal for companies seeking group staff transport with reliability and ease."
  },
  {
    "name": "Corporate AC Bus Rental Pune",
    "description": "Choose eTravo’s corporate AC bus rental in Pune for seamless employee movement. Our buses are maintained to high standards and come with trained drivers, perfect for office commutes and corporate travel plans."
  },
  {
    "name": "Comfortable Staff Commute Pune",
    "description": "Ensure a smooth ride with eTravo’s comfortable staff commute services in Pune. Our AC buses offer cushioned seating, safe travel, and timely pickups for employees traveling across the city."
  },
  {
    "name": "Large Group Employee Transport Pune",
    "description": "Transport large groups efficiently with eTravo’s employee transport solutions in Pune. Our fleet of high-capacity AC buses is perfect for factories, IT companies, and corporate campuses with bulk staff movement needs."
  },
  {
    "name": "Executive Bus Services Pune",
    "description": "eTravo provides executive bus services in Pune, tailored for leadership teams, senior employees, or corporate events. Our luxury AC buses ensure a premium commuting experience with style and punctuality."
  },
  {
    "name": "Monthly Bus Hire for Companies Pune",
    "description": "Opt for monthly bus hire for companies in Pune with eTravo. Our fixed plans help manage staff transport budgets, offering uninterrupted AC bus service with flexible scheduling for any business size."
  },
  {
    "name": "End-to-End AC Bus Mobility Pune",
    "description": "eTravo delivers end-to-end AC bus mobility solutions in Pune—from route planning and real-time tracking to staff safety and service support—ensuring full control over your employee transport."
  },
  {
    "name": "Affordable Employee Bus Services Pune",
    "description": "Get the best value with eTravo’s affordable employee bus services in Pune. We combine cost-efficiency with service quality to support startups, SMEs, and enterprises with their daily staff transport needs."
  },
  {
    "name": "Business Bus Rentals Pune",
    "description": "eTravo’s business bus rentals in Pune are ideal for team outings, inter-office shuttles, and large group travel. Our buses are available for short-term, event-specific, or recurring transport requirements."
  },
  {
    "name": "Shuttle Services for Office Staff Pune",
    "description": "Offer reliable shuttle services for office staff in Pune with eTravo. We operate AC bus shuttles on dedicated routes, ensuring employees arrive on time and in comfort every day."
  },
  {
    "name": "Customized AC Bus Plans Pune",
    "description": "eTravo creates customized AC bus plans in Pune based on shift timings, pickup locations, and staff size. We offer dynamic scheduling, route optimization, and scalable solutions for growing teams."
  },
  {
    "name": "Reliable Staff Bus Commute Pune",
    "description": "eTravo ensures a reliable staff bus commute in Pune with GPS-tracked buses, verified drivers, and dedicated support. Perfect for businesses needing dependable daily staff movement."
  },
  {
    "name": "Industrial Area Bus Services Pune",
    "description": "Support your workforce in Pune’s industrial zones with eTravo’s industrial area bus services. Our AC buses cover key MIDC locations and manufacturing hubs with timely pickup and drop schedules."
  },
  {
    "name": "Pune Staff Transport via AC Bus",
    "description": "eTravo specializes in Pune staff transport via AC buses, offering consistent and comfortable travel for companies across sectors—from tech firms to manufacturing units—with professional service standards."
  },
  {
    "name": "Long-Term Bus Hire for Employees Pune",
    "description": "Secure long-term bus hire for employees in Pune with eTravo. Our fixed-term contracts offer flexibility, cost savings, and continuous support for your corporate transport operations."
  }
],
"tableData": [
  ["AC Bus Hire for Employees Pune", "Corporate AC Bus Rental Pune"],
  ["Comfortable Staff Commute Pune", "Large Group Employee Transport Pune"],
  ["Executive Bus Services Pune", "Monthly Bus Hire for Companies Pune"],
  ["End-to-End AC Bus Mobility Pune", "Affordable Employee Bus Services Pune"],
  ["Business Bus Rentals Pune", "Shuttle Services for Office Staff Pune"],
  ["Customized AC Bus Plans Pune", "Reliable Staff Bus Commute Pune"],
  ["Industrial Area Bus Services Pune", "Pune Staff Transport via AC Bus"],
  ["Long-Term Bus Hire for Employees Pune", ""]
],





"whychoose": [
    {
        "WhyChooseheading": "Comfortable AC Bus Hire for Employees in Pune",
        "WhyChoosedescription": "eTravo offers reliable and fully air-conditioned bus hire services for employee transportation across Pune. Ideal for medium to large teams, our AC buses ensure a safe, punctual, and comfortable daily commute for your workforce."
    },
    {
        "WhyChooseheading": "Spacious and Well-Maintained AC Buses",
        "WhyChoosedescription": "Our fleet includes 18-seater, 32-seater, and 49-seater AC buses, all regularly serviced and maintained to provide a smooth and relaxed travel experience—even during Pune’s hot summers and long commutes."
    },
    {
        "WhyChooseheading": "Tailored Routes and Shift-Compatible Schedules",
        "WhyChoosedescription": "Whether your office operates in Hinjewadi, Hadapsar, or Chakan, our AC bus services are fully customizable to match your shift timings and pickup/drop locations—reducing travel stress and improving staff punctuality."
    },
    {
        "WhyChooseheading": "Trained Drivers and Onboard Safety Protocols",
        "WhyChoosedescription": "Our bus drivers are background-verified, uniformed, and experienced with Pune’s major routes. Each AC bus comes equipped with seat belts, GPS, a first aid kit, and fire safety equipment for a secure ride."
    },
    {
        "WhyChooseheading": "Cost-Effective Transport for Large Teams",
        "WhyChoosedescription": "Hiring AC buses is a scalable and economical option for companies looking to transport large groups of employees. eTravo’s pricing plans are transparent and tailored to your route, frequency, and fleet size."
    },
    {
        "WhyChooseheading": "GST-Compliant Billing and Monthly Reporting",
        "WhyChoosedescription": "Our corporate clients benefit from easy-to-manage, GST-compliant billing along with detailed monthly statements—helping your finance and HR teams track and control employee transport costs efficiently."
    },
    {
        "WhyChooseheading": "Cleanliness, Comfort, and Climate Control",
        "WhyChoosedescription": "Each AC bus undergoes routine cleaning and comes with climate-controlled interiors, cushioned seats, and wide aisles—ensuring your employees arrive at work fresh, relaxed, and ready to perform."
    },
    {
        "WhyChooseheading": "24/7 Support and Real-Time Bus Tracking",
        "WhyChoosedescription": "Our operations team monitors every ride in real time and offers round-the-clock assistance. Whether it’s route changes, delays, or emergencies, we coordinate closely with your admin team to ensure smooth transport operations."
    }
]
















    }

const faqData = [
    [
        {
            question: 'Does eTravo offer AC bus hire for employee transport in Pune?',
            answer: 'Yes, eTravo provides AC bus hire services in Pune specifically for employee transport, offering comfortable, air-conditioned travel for daily commutes, shift operations, and inter-office shuttles.',
        },
        {
            question: 'What bus capacities are available for hire in Pune?',
            answer: 'Our AC bus fleet in Pune includes 13-seater, 20-seater, 32-seater, and 50-seater options, ideal for transporting small to large employee groups efficiently and comfortably.',
        },
        {
            question: 'Are the AC buses equipped with safety and tracking features?',
            answer: 'Absolutely. All AC buses are GPS-tracked in real time and come with verified drivers, CCTV options (if required), digital logs, and compliance with corporate safety protocols.',
        },
        {
            question: 'Is eTravo’s AC bus hire available for multiple shifts and custom routes?',
            answer: 'Yes, we support multi-shift employee transport and offer custom routing with optimized pick-up and drop planning to match your operational schedules.',
        },
        {
            question: 'Do clients receive dedicated coordination for AC bus hire in Pune?',
            answer: 'Yes, a dedicated account manager is assigned to manage scheduling, fleet coordination, escalations, and service reporting for all AC bus hire engagements in Pune.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Deepak Sharma',
        designation: 'Admin Officer, LogicStream Technologies, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We hired AC buses from eTravo for our employee transport in Pune, and the experience has been smooth and reliable. Their buses are clean, punctual, and well-maintained.”',
    },
    {
        name: 'Ms. Meenal Katre',
        designation: 'HR Executive, VectorEdge Solutions, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s AC bus service in Pune has made daily commutes far more comfortable for our team. Great support staff and top-notch coordination throughout.”',
    },
];















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "AC Bus Hire for Employees Pune",
  "image": "https://www.etravo.in/images/keyword/ac-bus-hire-pune.jpg",
  "description": "Comfortable and reliable AC bus hire services for employees in Pune. Corporate AC bus rentals, executive bus services, large group transport, and customized plans for staff commute.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6009"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/ac-bus-hire-for-employees-pune"
  }
};









    return (
        <div>
<Helmet>
  <title>AC Bus Hire for Employees Pune | Corporate Staff Commute & Shuttle Services | eTravo</title>
  <meta 
    name="description" 
    content="Hire comfortable and affordable AC buses for employee transport in Pune with eTravo. Corporate AC bus rentals, executive services, large group transport, and customized commute plans." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/108.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Acbushireforemployees;